/**
 * ContextMenuProvider
 *
 * Coordinates context menu state across the application.
 * Ensures only one context menu is open at a time.
 */

import { FC, ReactNode, useState, useCallback } from 'react';
import { ContextMenuContext } from './ContextMenuContext';

type ContextMenuProviderProps = {
  children: ReactNode;
};

const ContextMenuProvider: FC<ContextMenuProviderProps> = ({ children }) => {
  const [activeMenuId, setActiveMenuId] = useState<string | null>(null);

  const openMenu = useCallback((menuId: string) => {
    setActiveMenuId(menuId);
  }, []);

  const closeMenu = useCallback((menuId: string) => {
    setActiveMenuId((current) => (current === menuId ? null : current));
  }, []);

  return (
    <ContextMenuContext.Provider value={{ activeMenuId, openMenu, closeMenu }}>
      {children}
    </ContextMenuContext.Provider>
  );
};

export { ContextMenuProvider };
